// extracted by mini-css-extract-plugin
module.exports = {"greyColor":"#d3d8dd","headingField":"LinkWrapper_headingField__3Hw7E","error":"LinkWrapper_error__3lfxE"};